import axios from 'axios';
import store from 'store';
import { operations as errorOps } from 'components/ErrorDialog/duck';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.response.use(
  response => response,
  error => {
    store.dispatch(errorOps.showError(error));
    return Promise.reject(error);
  }
);



export default api;
